export const environment = {
    production: false,
    useEmulators: true,
    hmr: true,
    apiRoot: 'http://localhost:1337/',
    whitelistedDomains: ['apps.linescale.com/node'],
    blacklistedRoutes: ['apps.linescale.com/node/auth'],
    nodeURL: 'apps.linescale.com/',
    gapi: {
        client: '210014939830-e4cq3jhq1cdra0g0uupl0k64kp7t77ab.apps.googleusercontent.com',
        apiKey: 'AIzaSyAzY_ztXX80qkCgTeK4vo26GPXqJcsCqns'
    },
    firebase: {
        apiKey: "AIzaSyCv9nGX-g9Ecwo6o8R8a3ZqXFqpC9Ox79w",
        authDomain: "linescale-dev.firebaseapp.com",
        databaseURL: "https://linescale-dev.firebaseio.com",
        projectId: "linescale-dev",
        storageBucket: "linescale-dev.appspot.com",
        messagingSenderId: "210014939830",
        appId: "1:210014939830:web:d28fa9b724937004491417"
    },
    cookieKey: 'ls_auth_token',
    // Production resources
    // apiURL: 'https://api.h2delta.com',
    // apiURL: '/reports',
    // gqlURL: 'https://ls-gql-toap3w6poa-uc.a.run.app/graphql',
    // fbAuthURL: 'https://us-central1-linescale-dev.cloudfunctions.net/api/auth',
    // authURL: 'https://us-central1-linescale-dev.cloudfunctions.net/authApi',
    // adminURL: 'https://us-central1-linescale-dev.cloudfunctions.net/api/admin',
    // cloudFuncsUrl: 'https://us-central1-linescale-dev.cloudfunctions.net',
    // surveyManageUrl: 'http://localhost:5001/linescale-dev/us-central1/api/survey',
    fileExportURL: 'https://api.h2delta.com',

    // Normal firebase serve
    // apiURL: '/local',
    // gqlURL: 'http://localhost:4112/graphql',
    // fbAuthURL: 'http://localhost:5000/linescale-dev/us-central1/api/auth',
    // authURL: 'http://localhost:5000/linescale-dev/us-central1/authApi',
    // adminURL: 'http://localhost:5000/linescale-dev/us-central1/api/admin'

    // Staging env
    // apiURL: 'https://core-api-sau5de4kaq-uc.a.run.app',
    // gqlURL: 'https://ls-gql-toap3w6poa-uc.a.run.app/graphql',
    // fbAuthURL: 'https://us-central1-linescale-b32e3.cloudfunctions.net/api/auth',
    // authURL: 'https://us-central1-linescale-b32e3.cloudfunctions.net/authApi',
    // adminURL: 'https://us-central1-linescale-b32e3.cloudfunctions.net/api/admin',
    // cloudFuncsUrl: 'https://us-central1-linescale-b32e3.cloudfunctions.net',
    // surveyManageUrl: 'http://localhost:5001/linescale-b32e3/us-central1/api/survey',

    // Firebase emulators
    apiURL: '/dev',
    gqlURL: 'http://localhost:4112/graphql',
    authURL: 'http://localhost:5001/linescale-dev/us-central1/authApi',
    // adminURL: 'http://localhost:5001/linescale-dev/us-central1/api/admin',
    adminURL: '/funcs/admin',
    surveyManageUrl: 'http://localhost:5001/linescale-dev/us-central1/api/survey',
    cloudFuncsUrl: 'http://localhost:5001/linescale-dev/us-central1',
    // fbAuthURL: 'http://localhost:5001/linescale-dev/us-central1/authApi',
    builderURL: 'https://localhost:5173',
  clientPortalUrl: 'http://localhost:3000',
  resetId: '2025-06-1',
  reportUrl: 'http://localhost:4200'
};
